import { createFileRoute } from "@tanstack/react-router";
import Login from "../pages/Login";

export const Route = createFileRoute("/login")({
	component: Login,
	validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
		return typeof search.redirect === "string" ? { redirect: search.redirect } : {};
	},
});
